import React, { useState, useEffect, useRef } from 'react';
import './Contact.css';
import motokoIcon from "../assets/internet-computer-icp-logo.svg"

const Contact = () => {
  const [techIcons, setTechIcons] = useState([]);
  const containerRef = useRef(null);

  const techStackData = [
    { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
    { name: 'JavaScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' },
    { name: 'TypeScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg' },
    { name: 'Python', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg' },
    { name: 'C++', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg' },
    { name: 'Java', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg' },
    { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
    { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
    { name: 'HTML5', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg' },
    { name: 'CSS3', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg' },
    { name: 'Git', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg' },
    { name: 'Qt', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/qt/qt-original.svg' },
    { name: 'PostgreSQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg' },
    { name: 'Motoko', icon: motokoIcon }
  ];

  useEffect(() => {
    const initIcons = techStackData.map((tech, index) => ({
      ...tech,
      id: index,
      x: Math.random() * 80 + 10,
      y: Math.random() * 60 + 10,
      vx: (Math.random() - 0.5) * 0.5,
      vy: (Math.random() - 0.5) * 0.5
    }));
    setTechIcons(initIcons);

    const animateIcons = () => {
      setTechIcons(prevIcons =>
        prevIcons.map(icon => {
          let newX = icon.x + icon.vx;
          let newY = icon.y + icon.vy;
          let newVx = icon.vx;
          let newVy = icon.vy;

          if (newX <= 5 || newX >= 95) {
            newVx = -newVx;
            newX = newX <= 5 ? 5 : 95;
          }
          if (newY <= 5 || newY >= 85) {
            newVy = -newVy;
            newY = newY <= 5 ? 5 : 85;
          }

          return { ...icon, x: newX, y: newY, vx: newVx, vy: newVy };
        })
      );
    };

    const interval = setInterval(animateIcons, 30);
    return () => clearInterval(interval);
  }, []);

  const handleIconHover = (id, mouseX, mouseY) => {
    setTechIcons(prevIcons =>
      prevIcons.map(icon => {
        if (icon.id === id) {
          // Calculate direction away from mouse
          const iconCenterX = icon.x;
          const iconCenterY = icon.y;
          const deltaX = iconCenterX - mouseX;
          const deltaY = iconCenterY - mouseY;
          const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
          
          // Normalize and create escape velocity
          const escapeSpeed = 3;
          const newVx = (deltaX / distance) * escapeSpeed + (Math.random() - 0.5) * 0.5;
          const newVy = (deltaY / distance) * escapeSpeed + (Math.random() - 0.5) * 0.5;
          
          return { ...icon, vx: newVx, vy: newVy };
        }
        return icon;
      })
    );
  };

  

  return (
    <section className="contact" id="contact">
      <div className="contact-background" ref={containerRef}>
        {techIcons.map(icon => (
          <div
            key={icon.id}
            className="floating-tech-icon"
            style={{
              left: `${icon.x}%`,
              top: `${icon.y}%`
            }}
            onMouseEnter={(e) => {
              const rect = containerRef.current.getBoundingClientRect();
              const mouseX = ((e.clientX - rect.left) / rect.width) * 100;
              const mouseY = ((e.clientY - rect.top) / rect.height) * 100;
              handleIconHover(icon.id, mouseX, mouseY);
            }}
          >
            <img src={icon.icon} alt={icon.name} />
          </div>
        ))}
      </div>

      <div className="contact-container">
        <div className="contact-content-wrapper">
          <div className="contact-header">
            <h3 className="script-greeting">Feel Free to Say Hi</h3>
            <h2 className="contact-title">LET'S <span className="pink-text">CONNECT</span></h2>
          </div>

          <div className="contact-links">
            <a href="mailto:marusickristijana@gmail.com" className="contact-link-card">
              <div className="contact-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div className="contact-link-text">
                <h4>Message Me</h4>
                <p>marusickristijana@gmail.com</p>
              </div>
            </a>

            <a href="https://github.com/kristiana19" target="_blank" rel="noopener noreferrer" className="contact-link-card">
              <div className="contact-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34-.46-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.87 1.52 2.34 1.07 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.92 0-1.11.38-2 1.03-2.71-.1-.25-.45-1.29.1-2.64 0 0 .84-.27 2.75 1.02.79-.22 1.65-.33 2.5-.33.85 0 1.71.11 2.5.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.35.2 2.39.1 2.64.65.71 1.03 1.6 1.03 2.71 0 3.82-2.34 4.66-4.57 4.91.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2z"/>
                </svg>
              </div>
              <div className="contact-link-text">
                <h4>GitHub</h4>
                <p>@kristiana19</p>
              </div>
            </a>

            <a href="https://www.linkedin.com/in/kristijana-maru%C5%A1i%C4%87" target="_blank" rel="noopener noreferrer" className="contact-link-card">
              <div className="contact-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.22 24h4.56V7.98H.22V24zM8.98 7.98H13.3v2.19h.06c.6-1.13 2.07-2.32 4.26-2.32 4.56 0 5.4 3 5.4 6.9V24h-4.56v-7.96c0-1.9-.03-4.35-2.65-4.35-2.65 0-3.06 2.07-3.06 4.2V24H8.98V7.98z"/>
                </svg>
              </div>

              <div className="contact-link-text">
                <h4>LinkedIn</h4>
              </div>
            </a>

          </div>
        </div>

        <footer className="footer">
          <p>© {new Date().getFullYear()} Kristijana. All rights reserved.</p>
        </footer>
      </div>
    </section>
  );
};

export default Contact;